// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_2vdpO","tooltip":"_1dUXj"};